import AuthScreens from 'Layout/AuthScreens.js'
import WrappedNormalLoginForm from 'pages/loginPage/LoginForm.js'
import React from 'react'

export default function LoginPage() {
  return (
    <AuthScreens component={<WrappedNormalLoginForm/>} />
  )
}
